export function Privacy() {
  return (
    <main className="legal-shell">
      <section className="legal-panel" aria-labelledby="privacy-title">
        <p className="eyebrow">Privacy</p>
        <h1 id="privacy-title">Miles Systems privacy policy</h1>
        <p>
          The public contact form collects the name, email, company, message, source URL, and timestamp needed to respond
          to a request. Admin access uses GitHub OAuth and stores the GitHub account identifier for allowlisted
          operators.
        </p>
        <p>
          The site does not include public signup, client accounts, payment flows, or third-party advertising scripts in
          this release.
        </p>
        <p>
          Contact requests are stored in the app-owned PostgreSQL database deployed for Miles Systems and are visible
          only from the admin dashboard.
        </p>
        <a className="button ghost" href="/">Back to site</a>
      </section>
    </main>
  );
}

